"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _CheckCanOpenComponent = _interopRequireDefault(require("../../MainMenu/CheckCanOpenComponent"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var EquizzerTrainingCanOpenChecker = /*#__PURE__*/function (_CheckCanOpenComponen) {
  (0, _inherits2["default"])(EquizzerTrainingCanOpenChecker, _CheckCanOpenComponen);

  var _super = _createSuper(EquizzerTrainingCanOpenChecker);

  function EquizzerTrainingCanOpenChecker(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, EquizzerTrainingCanOpenChecker);
    _this = _super.call(this, props);
    _this.state = {};
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(EquizzerTrainingCanOpenChecker.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, []);
    return _this;
  }
  /**
   * Overridden from CheckCanOpenComponent
   */


  (0, _createClass2["default"])(EquizzerTrainingCanOpenChecker, [{
    key: "onOpen",
    value: function () {
      var _onOpen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _promise["default"].resolve(true));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onOpen() {
        return _onOpen.apply(this, arguments);
      }

      return onOpen;
    }()
  }]);
  return EquizzerTrainingCanOpenChecker;
}(_CheckCanOpenComponent["default"]);

var _default = EquizzerTrainingCanOpenChecker;
exports["default"] = _default;